import gql from 'graphql-tag';

const ARTICLES_QUERY = gql`
    query Articles($where: JSON)  {
        articleEntries (
            sort: "published_at:desc"
            where: $where
        ) {
            id
            slug
            title
            title_highlighted_words
            description
            published_at
            date
            categories {
                id
                title
            }
            hero {
                url
            }
            meta {
                page_title
                page_description
            }
        }
    }
`;

export default ARTICLES_QUERY;
